import { items as itemsApi } from '@afosto/order/api/Items';

export default async (order, items, currentItems) => {
  try {
    const currentItemReferences = { ...(currentItems ?? {}) };
    const { add, remove } = items.reduce(
      (acc, item) => {
        const quantity = parseInt(item?.quantity ?? 0, 10);
        const orderItem = currentItemReferences[item.reference];
        const currentQuantity = parseInt(orderItem?.quantity ?? 0, 10);
        const difference = Math.abs(quantity - currentQuantity);
        const itemData = {
          reference: item.reference,
          sku: item.sku,
          description: item.description,
        };
        const ids = orderItem?.ids ?? [];

        delete currentItemReferences[item.reference];

        if (quantity < 0 && currentQuantity < 0) {
          if (quantity < currentQuantity) {
            return {
              ...acc,
              add: [...acc.add, { ...itemData, quantity: difference, is_inbound: true }],
            };
          }

          return {
            ...acc,
            remove: [...acc.remove, ...ids.slice(0, difference)],
          };
        }

        if (quantity > 0 && currentQuantity > 0) {
          if (quantity > currentQuantity) {
            return {
              ...acc,
              add: [...acc.add, { ...itemData, quantity: difference, is_inbound: false }],
            };
          }

          return {
            ...acc,
            remove: [...acc.remove, ...ids.slice(0, difference)],
          };
        }

        if (quantity > 0 && currentQuantity < 0) {
          return {
            ...acc,
            add: [...acc.add, { ...itemData, quantity, is_inbound: false }],
            remove: [...acc.remove, ...ids],
          };
        }

        if (quantity < 0 && currentQuantity > 0) {
          return {
            ...acc,
            add: [...acc.add, { ...itemData, quantity: Math.abs(quantity), is_inbound: true }],
            remove: [...acc.remove, ...ids],
          };
        }

        if (quantity === 0 && currentQuantity !== 0) {
          return {
            ...acc,
            remove: [...acc.remove, ...ids],
          };
        }

        if (currentQuantity === 0 && quantity !== 0) {
          return {
            ...acc,
            add: [
              ...acc.add,
              { ...itemData, quantity: Math.abs(quantity), is_inbound: quantity < 0 },
            ],
          };
        }

        return acc;
      },
      { add: [], remove: [] },
    );

    const deletedItemIds = [
      ...(remove ?? []),
      ...Object.values(currentItemReferences).reduce(
        (acc, orderItem) => [...acc, ...(orderItem.ids ?? [])],
        [],
      ),
    ];

    if (deletedItemIds.length > 0) {
      await itemsApi.deleteItems(order.id, deletedItemIds);
    }

    let addedItems = [];

    if (add.length > 0) {
      const itemsResponse = await itemsApi.addItems(order.id, add);
      addedItems = itemsResponse?.data ?? [];
    }

    return addedItems;
  } catch (err) {
    return Promise.reject(err);
  }
};
